module.exports = __webpack_public_path__ + "img/deragopyan-alt.75506e55.png";